/// <reference lib="dom" />
import type { ChartLayer } from "../core/chart.ts";
import { type ChartAxis, ScaleOf, Single } from "./shared.ts";

export interface RefLineLayerOpts {
  axis: ChartAxis;
  value: number;
  dashed?: boolean;
  color?: string;
}

export function RefLineLayer(opts: RefLineLayerOpts): ChartLayer {
  return {
    id: `ref-${opts.axis}`,
    clip: true,
    render(root, ctx) {
      const scale = ScaleOf(ctx, opts.axis);
      const { inner } = ctx.frame;
      const pos = scale(opts.value);
      Single<SVGLineElement>(root, "line", "ref")
        .attr("x1", opts.axis === "x" ? pos : inner.left)
        .attr("x2", opts.axis === "x" ? pos : inner.right)
        .attr("y1", opts.axis === "x" ? inner.top : pos)
        .attr("y2", opts.axis === "x" ? inner.bottom : pos)
        .attr("stroke", opts.color ?? ctx.theme.refLine)
        .attr("stroke-width", 1)
        .attr("stroke-dasharray", opts.dashed ?? true ? "2,2" : null)
        .attr("shape-rendering", "crispEdges");
    },
  };
}
